export type ArenaWeeklyMediaLocale = 'ja' | 'en';

/** UI 言語 → 週次 PDF/動画の表示 locale（ja のみ日本語、それ以外は英語） */
export function resolveArenaWeeklyMediaLocale(uiLanguage: string): ArenaWeeklyMediaLocale {
  return uiLanguage.startsWith('ja') ? 'ja' : 'en';
}

export function arenaWeeklyMediaLocaleLabel(locale: ArenaWeeklyMediaLocale): string {
  return locale === 'ja' ? 'JP' : 'EN';
}

/**
 * 希望メディア言語に実ファイルが無いとき、他方へフォールバック。
 * どちらも無ければ null。
 */
export function resolveAvailableArenaMediaLocale(
  preferred: ArenaWeeklyMediaLocale,
  available: { hasJa: boolean; hasEn: boolean }
): ArenaWeeklyMediaLocale | null {
  if (preferred === 'en') {
    if (available.hasEn) return 'en';
    if (available.hasJa) return 'ja';
    return null;
  }
  if (available.hasJa) return 'ja';
  if (available.hasEn) return 'en';
  return null;
}
